import AppModal from "components/Modal"; 
import React, { 
    useEffect, 
    useState, 
}  from 'react';
import ReactDOM from "react-dom"; 
import { useAuth } from '../../../helpers/authContext';

import {
    // Alert,
    Button, 
  Card,
  CardBody,
  Col, 
  FormGroup, 
  Input,
  Row, 
} from "reactstrap"; 
import { useToast } from "components/ui/use-toast"; 
import useModal from "helpers/useModal";
import LoginModal from "./LoginModal"; 
import { isLoggedWithKeychain, numberWithCommas } from "services/dsteem-service";
import { delegateKeychain  } from "helpers/keychain";
import { delegateWithWif, tokenToBalance, vests2SP  } from "helpers/steem"; 
import { getUser } from "services/user-service";
import { get_plans } from "services/db-service";
type Props = {
  isShowing: boolean,
  hide: any, 
  symbol?:string,
  outgoing_delegations?:any,
  mvest:any,
  initialTo?: string,
  initialAmount?: string | number,
  autoConfirm?: boolean,
  onSuccess?: () => void;
}
const MINIMUN_SP_FOR_PLUS = parseInt(process.env.MINIMUN_SP_FOR_PLUS) || 1000;
export const DelegateModal = ({ isShowing, hide, symbol="STEEM",outgoing_delegations=[],mvest, initialTo="", initialAmount="", autoConfirm=false, onSuccess = null}: Props) => { 
    const { user, autologin } = useAuth(); 
    const [requiredActive, setRequiredActive] = useState<any>(true);
    const keychainLogin = isLoggedWithKeychain(autologin); 
    const [availableSP, setAvailableSP] = useState<any>(0);
    const [transferReceiver, setTransferReceiver] = useState<any>(""); 
    const [transferAmount, setTransferAmount] = useState<any | "">("");
    const [currentDelegation, setCurrentDelegation] = useState<any>({});
    const [suggestion, setSuggestion] = useState<{
        type: "up" | "down" | "neutral";
        amount?: number;
        message: string;
        }>({
        type: "neutral",
        message: ""
    }); 
    // const [suggestionMessage, setSuggestionMessage] = useState<any>("");
    const [isPlus, setIsPlus] = useState<any>(false);
    const [isDelegating, setIsDelegating] = useState(false); 
    const [step, setStep] = useState<any>(1);
    const [showConfirm, setShowConfirm] = useState(false);
    const [transferSymbol, setTransferSymbol] = useState<any>(symbol); 
    const { isOpenLoginModal, toggleLoginModal  } = useModal();
    const { toast } = useToast();
    useEffect(()=> { 
        if (isShowing) {
            if (initialTo) setTransferReceiver(initialTo);
            if (initialAmount !== "") setTransferAmount(initialAmount);
            if (autoConfirm && initialTo && initialAmount !== "") {
                setShowConfirm(true);
            } else {
                setShowConfirm(false);
            }
        }
        async function getAvailableFunds (){
            try {
                const [userInfo] = await Promise.all([ 
                    getUser(user),
                ]); 
                let sp = vests2SP(userInfo.vesting_shares, mvest) || 0.000;
                let delegated = vests2SP(userInfo.delegated_vesting_shares, mvest) || 0.000;
                let received = vests2SP(userInfo.received_vesting_shares, mvest) || 0.000;
                let pd = vests2SP(userInfo.vesting_withdraw_rate, mvest) || 0.000;
                let totalSP:any = parseFloat((sp - delegated - pd + received).toFixed(3)) || 0.000;
                setAvailableSP(parseFloat(totalSP) || 0)
            } catch (error) {
                toast({title:"Error", description:error, variant:"rose_red"});
            }
            
        }
        getAvailableFunds(); 

        const getPlans = async () => { 
            let data = await get_plans(); 
            const plan = data.find(u => u.username === user);  
            let plus = plan?.plan_type?.includes("plus") || false;
            setIsPlus(plus); 
        }
        getPlans(); 
    },[isShowing]); 
    useEffect(()=> {
        for (let i = 0; i < outgoing_delegations.length; i++) {
            const element = outgoing_delegations[i];
            if (element.delegatee == transferReceiver) {
                let amount = parseFloat(tokenToBalance(element.vesting_shares, mvest));
                setCurrentDelegation({username:transferReceiver, amount});
            }
        }
    },[transferReceiver]); 
    useEffect(() => {
        if (currentDelegation?.amount && transferAmount !== "") {
            const delegatedAmount = parseFloat(currentDelegation.amount);
            const newAmount = parseFloat(transferAmount as any);

            if (newAmount < delegatedAmount) {
            const diff = delegatedAmount - newAmount;
            setSuggestion({
                type: "down",
                amount: diff,
                message: `Decrease by ${numberWithCommas(diff.toFixed(3))} SP`
            });
            } else if (newAmount > delegatedAmount) {
            const diff = newAmount - delegatedAmount;
            setSuggestion({
                type: "up",
                amount: diff,
                message: `Increase by ${numberWithCommas(diff.toFixed(3))} SP`
            });
            } else {
            setSuggestion({
                type: "neutral",
                message: "No change in delegation"
            });
            }
        } else {
            setSuggestion({
            type: "neutral",
            message: "Set a higher amount than the previous one to increase it."
            });
        }
    }, [transferAmount, currentDelegation]); 


    const handleDelegate = async (newWif = "") => { 
        // if (transferAmount) {
            
            const fn = keychainLogin ? delegateKeychain : delegateWithWif;
            const account = keychainLogin ? user : autologin; 
            setIsDelegating(true);
            let res:any = await fn(account, transferReceiver, transferAmount,mvest, newWif);
            setIsDelegating(false)
            if (!res.success) { 
                if(res?.message.toString().includes("Missing Active Authority")){ 
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                } else {
                   toast({
                        title:"Failed delegating sp.",
                        description:res,
                        variant:"rose_red"
                    }); 
                }
                
            }else {
                toast({
                title:"Steem Power delegated successfully.",
                description:"You have delegated Steem Power to another account.",
                variant:"wild_green"
                }); 
                setTransferAmount(0);
                setTransferReceiver(""); 
                setStep(1);
                setShowConfirm(false);
                if (onSuccess) {
                    onSuccess();
                } 
                hide();
            }
        // }else{
        //     toast({
        //         title:"Failed sending funds.",
        //         description:"You need to set an amount.",
        //         variant:"rose_red"
        //     });
        // }
    }
    const renderForm = (
        <div className="modal-body post-editor-body p-0">
        <Card className="no-shadow border-0">
            {user && (
                <CardBody className="px-lg-3 py-lg-3 body-gray"> 
                    {step == 1 && (
                        <Row>
                            <Col md="12">
                                <p className="promotion-description">
                                    <b>Delegate Steem Power.</b> You can "lend" your Steem Power to other Steem accounts through the delegations, the delegated Steem Power will be used by the account to which you delegate, however, the Steem Power will never stop being your property. 
                                    <i>You can withdraw your delegations at any time and the SP takes 5 days to return to your account.</i><br /><br />

                                If you want to increase your delegation to an account, you need to enter the final amount (i.e, if you already delegate to X 200 SP and want to increase to 500 SP, set the account name and 500) <br />
                                If you want to undelegate, enter the account name and 0 (zero) as amount.
                                </p>   
                            </Col>
                            <Col md="12">
                                <FormGroup>
                                    <div className="input-icon-group">
                                        <i className="fas fa-user input-icon" />
                                        <input type="text" className="form-control fancy-input" name="receiver" placeholder="Recipient" value={transferReceiver} onChange={(e) => {
                                            setTransferReceiver((e.target.value));

                                        }} />
                                    </div>
                                </FormGroup> 
                            </Col>
                            <Col className="col-8" md="8"> 
                                <FormGroup>
                                    <div className="input-icon-group">
                                        <i className="fas fa-coins input-icon" />
                                        <input type="number" className="form-control fancy-input" name="val" placeholder="Amount (SP)" value={transferAmount} onChange={(e) => setTransferAmount(parseFloat(e.target.value))} /> 
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col className="col-4" md="4"> 
                                <Input type="select" className="form-control fancy-input mb-3" name="symbol" value={transferSymbol} onChange={(e) => setTransferSymbol(e.target.value)} >
                                    <option value="STEEM">SP</option> 
                                </Input> 
                            </Col> 
                            {(availableSP >= MINIMUN_SP_FOR_PLUS && !isPlus) && (
                                <Col md="12" className="mb-3">
                                    <span>Suggested delegations:</span>
                                    <div className="suggested-delegation-item" onClick={()=> {
                                        setTransferReceiver("steem-seven");
                                        setTransferAmount(availableSP >= 2000? availableSP / 2 : MINIMUN_SP_FOR_PLUS);
                                    }}>
                                        <span className="suggested-name">@steem-seven</span>
                                        <span className="suggested-amount"><span className="balance-number">{availableSP >= 2000? availableSP / 2 : MINIMUN_SP_FOR_PLUS}</span> <span className="balance-currency">SP</span></span>
                                        <span className="suggested-description">Become plus member and get daily benefits.</span>
                                    </div>
                                </Col>
                            )} 
                            {(currentDelegation?.username && currentDelegation?.amount) && (
                                <Col md="12" className="mb-3">
                                    <span>Existing delegation found:</span>
                                    <div className="suggested-delegation-item" onClick={()=> {
                                        // setTransferReceiver("steem-seven");
                                        // setTransferAmount(availableSP >= 2000? availableSP / 2 : MINIMUN_SP_FOR_PLUS);
                                    }}>
                                        <span className="suggested-name">@{currentDelegation.username}</span>
                                        <span className="suggested-amount"><span className="balance-number">{numberWithCommas(currentDelegation.amount)}</span> <span className="balance-currency">SP</span></span>
                                        {/* <span className="suggested-description">
                                            {suggestionMessage}
                                        </span> */}
                                        <span
                                            className={`delegation-indicator ${
                                                suggestion.type === "up"
                                                ? "delegation-up"
                                                : suggestion.type === "down"
                                                ? "delegation-down"
                                                : "delegation-neutral"
                                            }`}
                                            >
                                            {suggestion.type === "up" && (
                                                <i className="fas fa-arrow-up" />
                                            )}
                                            {suggestion.type === "down" && (
                                                <i className="fas fa-arrow-down" />
                                            )}
                                            {suggestion.type === "neutral" && (
                                                <i className="fas fa-minus" />
                                            )}
                                            {suggestion.message}
                                        </span>

                                    </div>
                                </Col>
                            )} 
                            <Col md="12"> 
                                <Button color="default" className="w-100 btn-fancy" onClick={() => {
                                    if (transferReceiver && transferSymbol) {
                                        setShowConfirm(true);
                                    }else {
                                        toast({title:"Fill all fields first", description:"Set a proper  amount.", variant:"rose_red"});
                                    }
                                }}>
                                    Next <i className="fas fa-chevron-right ml-2" />
                                </Button> 
                            </Col>
                        </Row>
                    )}
                </CardBody>
            )}
            {!user && (<p>Please log in to transfer funds.</p>)}
        </Card>
        </div>
    );

  return (
    isShowing ? ReactDOM.createPortal(
      <React.Fragment>
        <AppModal
          isShowing={isShowing}
          hide={hide}
          size="md"
          header="Delegate Steem Power"
        >
            {renderForm}
            <AppModal isShowing={showConfirm} hide={() => !isDelegating && setShowConfirm(false)} size="md" header="Confirm Delegation">
                <div className="p-3 text-scheme">
                    <p className="text-muted">You are about to delegate Steem Power. Please review the details:</p>
                    <div className="mb-4 p-3 border rounded bg-speem-confirm">
                        <div className="mb-2">
                           <i className="fas fa-user mr-2 text-speem" /> <strong>Recipient:</strong> <span className="ml-2">@{transferReceiver}</span>
                        </div>
                        <div className="mb-0">
                           <i className="fas fa-coins mr-2 text-speem" /> <strong>Amount:</strong> <span className="ml-2">{transferAmount > 0 ? `${parseFloat(transferAmount).toFixed(3)} SP` : <span className="text-rose">Undelegate (0 SP)</span>}</span>
                        </div>
                    </div>
                    <div className="d-flex gap-3 mt-4">
                        <Button color="secondary" onClick={() => setShowConfirm(false)} disabled={isDelegating} className="w-100 mr-2 btn-fancy">
                            Cancel
                        </Button>
                        <Button color="default" onClick={() => handleDelegate()} disabled={isDelegating} className="w-100 btn-fancy position-relative">
                            {isDelegating ? (
                                <span className="spinner dark m-0" />
                            ) : keychainLogin ? (
                                <>
                                Confirm with
                                <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" />
                                </>
                            ) : (
                                "Confirm"
                            )}
                        </Button>
                    </div>
                </div>
            </AppModal>
        </AppModal>
        <LoginModal
            isShowing={isOpenLoginModal}
            hide={toggleLoginModal}
            requiredActive={requiredActive}
            onSuccess={({ wif }) => { 
                if (wif) {
                handleDelegate(wif);
                } 
            }}
            />
      </React.Fragment>, document.body
    ) : null)
};

export default DelegateModal;